// Mock data for ASH — The Witch Trials of Drudenhaus (frontend-only)

export const NAV = {
  title: 'ASH',
  subtitle: 'THE WITCH TRIALS OF DRUDENHAUS'
};

export const HERO = {
  eyebrow: 'AN INTIMATE HALLOWEEN TRIAL',
  title: 'ASH',
  tagline: 'The Witch Trials of Drudenhaus',
  question: "Can you prove you're not a witch?",
  cta: 'BOOK YOUR TRIAL',
  ctaSoldOut: 'SOLD OUT — JOIN THE LIST'
};

export const WHAT = {
  heading: 'what?',
  italic:
    '"Confess, and you can die clean."',
  body:
    "A live trial. You are the accused. Step inside a candlelit interrogation where history feels close enough to breathe on you. Face the Inquisitor. Uncover the town's dirty secret. Find the key hidden in the story. Escape before the House names you.",
  bullets: [
    'Face the Inquisitor',
    "Uncover the town's dirty secret",
    'Find the key hidden in the story',
    'Escape before the House names you'
  ],
  note:
    'For large group / private bookings please email producer@colabtheatre.co.uk with your preferred date and performance times.',
  refund:
    'Please note tickets cannot be refunded less than 24 hrs before the performance start time.'
};

export const HISTORY = {
  heading: 'real history. real fear.',
  lead: 'Rooted in the Bamberg trials',
  body:
    "Inspired by the Drudenhaus / Malefizhaus — Bamberg's purpose-built witch prison, opened in 1627 during one of Europe's most intense witch persecutions.",
  emphasis: 'Not fantasy horror.',
  themes: ['Interrogation.', 'Confession.', 'Faith.', 'Shame.']
};

export const SIGNATURE = {
  heading: 'the signature device',
  lead: 'the table becomes the village',
  body:
    "A small dolls-house world sits between the audience: church, healer's cottage, ash roads. Every mark that looks like witchcraft is revealed as proof the village came to her for help.",
  close: 'The ash is not a curse. It is a bandage.'
};

export const WHERE = {
  heading: 'where?',
  venue: 'The Cottage — a Tudor house at COLAB, London Bridge',
  address: '169a Borough High Street, London, SE1 1HR',
  addressLine2: '(a short walk from London Bridge & Borough stations)',
  detail:
    "COLAB's new venue, built for atmosphere rather than heavy set: one table, candlelight, sound, darkness and the characters' costumes. An audience of just two sit close enough to be personally accused.",
  format: 'an audience of two  ·  one performer  ·  deeply intimate'
};

export const BOOK = {
  heading: 'book',
  subheading: 'Choose your night. Choose who to trust. Leave before the House names you.',
  soldOut: true,
  soldOutNote:
    'Every sitting of the Court has been claimed. Sign up to the mailing list and you will be the first to hear when further tickets are released.'
};

export const GUIDANCE = {
  heading: 'content guidance',
  lead:
    'ASH is a close-contact horror experience for a two-person audience. Please read before booking.',
  age: 'Recommended 16+',
  triggers: [
    {
      title: 'Blindfolds',
      body:
        'Audience members will be blindfolded at points during the performance.'
    },
    {
      title: 'Physical contact',
      body:
        'You will be handled by the performer — led, held, guided and, at moments, restrained.'
    },
    {
      title: 'Close quarters & darkness',
      body:
        'Candlelight, near-total darkness and sudden sound. Not suitable for those with severe claustrophobia or light-sensitive conditions.'
    },
    {
      title: 'Adult themes',
      body:
        'Themes of persecution, interrogation, religious violence and shame. There is no explicit gore.'
    }
  ],
  optOut:
    'A safeword is available at all times. Blindfolds and physical contact can be opted out of at the door — the trial will adapt around you. If you have specific access needs, email producer@colabtheatre.co.uk before booking.'
};

export const TESTIMONIALS = [
  {
    quote: 'Terrifying, intimate and unlike anything I have ever sat through.',
    attribution: 'Tester Audience'
  },
  {
    quote: 'The Inquisitor looked me in the eye and I forgot how to breathe.',
    attribution: 'Tester Audience'
  },
  {
    quote: 'History pressed right up against your face. Genuinely unsettling.',
    attribution: 'Tester Audience'
  },
  {
    quote: 'A tiny room, one table, and forty of the most nerve-wracking minutes of my year.',
    attribution: 'Tester Audience'
  },
  {
    quote: 'I was accused. I was nearly convinced I had done something wrong.',
    attribution: 'Tester Audience'
  },
  {
    quote: 'Candlelit, whispered, cruel and beautiful. Do not go alone if you scare easily.',
    attribution: 'Tester Audience'
  }
];

export const FOOTER = {
  producer: 'A COLAB Theatre production',
  venue: 'The Cottage · COLAB · London Bridge',
  email: 'producer@colabtheatre.co.uk',
  copyright: `© ${new Date().getFullYear()} ASH — The Witch Trials of Drudenhaus. All rights reserved.`
};

export const IMAGES = {
  hero: '/ash/image-1-1.png',           // wide table + candles + audience
  inquisitor: '/ash/bertie-portrait.png',   // Bertie Watkins — the Inquisitor, portrait
  accused: '/ash/bertie-landscape.png',     // Bertie Watkins — leaning over the chained accused
  shadowed: '/ash/bertie-shadowed.png',     // Bertie Watkins — shadowed, candle right
  poster: '/ash/ash-poster.png',            // key art poster
  history: '/ash/image-4-1.png',        // wider interior (for history bg)
  village: '/ash/image-5-1.png',        // tabletop miniature village
  trial: '/ash/image-6-1.png',          // trial scene silhouettes
  doorway: '/ash/image-7-1.png'         // tudor doorway
};
